import React, { Component } from 'react';
import { connect } from 'react-redux';
import {InputText} from 'primereact/inputtext';
import {Dropdown} from 'primereact/dropdown';
import {DataTable} from 'primereact/datatable'
import {Column} from 'primereact/column';
import {Button} from 'primereact/button';
import CKEditor from "react-ckeditor-component";

import {Toast} from 'primereact/toast';
import Messages from '../../../shared/UI/Messages/Messages';
import * as actions from '../../../store/actions/index';
import FooterButton from '../../../shared/UI/FooterButton/FooterButton';
import { DROPDOWN_CONFIG, HELP_SUBMENU_ID } from '../../../shared/Config';
import { HASACCESS, scrollToTop } from '../../../shared/utility';
class HelpLibrary extends Component {
    state = {
        globalFilter: null,
        selectedMenu: null,
        description:'',
        type: 'Add'
    }


    onChange = (evt) =>{
        var newContent = evt.editor.getData();
        this.setState({
            description: newContent
        })
    }
    
    onBlur= (evt) =>{
    }
    
    afterPaste= (evt) =>{
    }

    componentDidMount(){        
        this.getAccess = HASACCESS(HELP_SUBMENU_ID);
        this.props.getMasterTableList('GetHelpLibrary');    
    }


    addLibrary = (menus) => {

        let subMenuID = this.state.selectedMenu;
        let menuID = menus.filter( val => {
            return val.value === subMenuID;
        }).reduce((menuID, el) => {
            return el.menuID;
        },'');

        if(menuID === ''){
            this.growl.show({severity: 'error', summary: null, detail: 'Menu ID is required'});
            return;
        }
     
        let data = {    
            menu : menuID,
            submenu: subMenuID,
            helpcontent: this.state.description
        }

       
     
        this.props.processDynamicData('HelpLibrary',this.state.type,data,'GetHelpLibrary');

    }
  

    menuRender = (rowData, menus) => {
        let mainMenu = rowData.menu;
        let result = '';
        if(menus && menus.length > 0){
            result = menus.filter((menu)=>{
                return mainMenu === menu.menuID
            }).reduce((result, el) => {
                return el.menuName;
            },'');
        }
        return result;
    }

    pageRender = (rowData, menus) => {
        let subMenu = rowData.page;
        let result = '';
        if(menus && menus.length > 0){
            result = menus.filter((menu)=>{
                return subMenu === menu.value
            }).reduce((result, el) => {
                return el.label;
            },'');
        }
        return result;
    }


    editItem = (menu,page,description,type) => {
        scrollToTop();
        if(page === '00000000-0000-0000-0000-000000000000'){
            this.growl.show({severity: 'error', summary: null, detail: 'Edit data has error'});
            return;
        }

        this.setState({type:type,selectedMenu:page,description:description})
    }

    deleteItem  = (item) => {
        const updatedValue = [{ DeleteID : item}];
        this.props.dynamicDeleteProcess('HelpLibrary',updatedValue,'GetHelpLibrary');
    }

    actionTemplate = (rowData, column) => {
            return  <div className="actionCenter">
                {(this.getAccess!==undefined && this.getAccess.editAccess!== false) &&
                    <Button type="button" icon="pi pi-pencil" onClick={()=>this.editItem(rowData.menu,rowData.page,rowData.description,'Edit')} className="p-button-info" ></Button>
                }

                {(this.getAccess!==undefined && this.getAccess.viewAccess!== false) &&  
                    <Button type="button" icon="pi pi-eye"  className="p-button-secondary" onClick={()=>this.editItem(rowData.menu,rowData.page,rowData.description,'View')} ></Button>
                }
                {(this.getAccess!==undefined && this.getAccess.deleteAccess!== false) &&
                    <Button type="button" icon="pi pi-trash" onClick={()=>this.deleteItem(rowData.page)} className="p-button-danger" ></Button>
                }
                </div>;
    }

    clear = ()=>{
        this.setState({type:'Add',selectedMenu:null,description:''})
    }



    render() {   


        let addAccess = true;
        let editAccess = true;
        if(this.getAccess!==undefined){
            if(this.getAccess.viewAccess === false){this.props.history.push('/dashboard')}
            addAccess = (this.getAccess.addAccess === true) ? true : false;
            editAccess = (this.getAccess.editAccess === true) ? true : false;
        }
        let accessButton = { addAccess : addAccess, editAccess : editAccess}


        let menus = [];
        if(this.props.menuLists && this.props.menuLists.length > 0){
            let subMenu = [];
            //let groupValue =[];
            this.props.menuLists.map((menu) => {
                if(menu.menuRights.length > 0){
                    subMenu = menu.menuRights.map((sub) => {
                        // if (groupValue.indexOf(sub.subMenuID) !== -1) {
                        //     return false;
                        // }else{  
                        //     groupValue.push(sub.subMenuID);
                        //     return {
                        //         label: sub.subMenuName, value : sub.subMenuID, menuID : sub.menuID, menuName : menu.mainmenu
                        //     }
                        // }
                        return {
                                     label: sub.subMenuName, value : sub.subMenuId, menuID : sub.menuID, menuName : menu.mainmenu
                               }
                    });
                    menus.push(...subMenu);
                }
                return subMenu;
            })
            menus = menus.filter(value => Object.keys(value).length !== 0);
        }
        
       
        const header = (
            <div style={{'textAlign':'right'}}>
                <InputText type="search" onInput={(e) => this.setState({globalFilter: e.target.value})} placeholder="Search..." />
            </div>
        );
        
        let isEnabled = (this.state.selectedMenu !== null) && (this.state.description !== '');

        let tableData = []    
        if(this.props.tableLists && this.props.tableLists.length > 0){
            tableData = this.props.tableLists.map(list => {
                return {menu: list.menu, page : list.submenu,description:list.helpcontent}
            })
        }



        return (
            <div className="p-grid padding1">
               { this.props.loading && <div className="page-loader"></div>}
               { this.props.error !== null && <Messages type="error" message={this.props.error}/>}
               <Toast ref={(el) => this.growl = el} />
               <div className="p-col-12">
                    <div className="card card-w-title" style={{position:'relative'}}>
                        <h1>Help Library</h1>
               
                        <div className="p-grid">

                            <div className="p-col-12 p-md-6 p-lg-6">
                            <label>Select Page</label>
                                <div className="mt1 ">
                                <Dropdown className="width100" options={menus} value={this.state.selectedMenu} 
                             onChange={(e) => this.setState({selectedMenu:e.target.value})} name="selectedMenu" placeholder="Select Page" {...DROPDOWN_CONFIG} />

                                </div>                                
                            </div>

                            <div className="p-col-12 p-lg-12">
                                <label> Descriptions</label>
                                <div className="mt1 ">
                                     <CKEditor 
                                        activeClass="p10" 
                                        content={this.state.description} 
                                        events={{
                                            "blur": this.onBlur,
                                            "afterPaste": this.afterPaste,
                                            "change": this.onChange
                                        }}
                                        />
                                </div>
                            </div>


                        
                            <div className="p-col-12 p-lg-12">
                                <FooterButton access={accessButton} disabled={!isEnabled} type={this.state.type.toLowerCase()} save={()=>this.addLibrary(menus)} reset={this.clear}  to="" />
                                <div className="mt1">
                                {/* {
                                    (this.state.type!=='View') &&
                                    <Button disabled={!isEnabled} style={{float:'right'}} label={labelName} icon={"pi "+iconName} className="ml1" onClick={()=>this.addLibrary(menus)} />
                                }
                                
                                <Button style={{float:'right'}} label="Reset" icon="pi pi-replay" className="ml1 p-button-secondary" onClick={this.clear} /> */}

                                


                                </div>                                
                            </div>
                     

                            					 	
                            <div className="p-col-12" style={{marginTop:'2em'}}>
                                <DataTable ref={(el) => this.dt = el} value={tableData} responsive className="p-datatable-customers animated fadeIn" rowHover paginator rows={10} emptyMessage="No data found" globalFilter={this.state.globalFilter} header={header}>
                                    {/* <Column field="menu" header="Menu Name" body={(rowData)=>this.menuRender(rowData,menus)}/> */}
                                    <Column field="page" header="Page Name" body={(rowData)=>this.pageRender(rowData,menus)}/>
                                    <Column field="description" header="Description" style={{display:'none'}}/>
                                    <Column body={this.actionTemplate} header="Action" />
                                </DataTable>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return{
        loggedUserDetail : state.auth.userObject,
        loading : state.master.loading,
        error : state.master.error,
        success: state.master.success,
        menuLists : state.auth.menuLists,
        tableLists : state.master.tableLists
    }
}
  
const mapDispatchToProps = dispatch => {
    return{
        getKeywordValues : (keyword) => dispatch(actions.getKeywordValues(keyword)),
        processDynamicData: (model,type,data,func) => dispatch(actions.processDynamicData(model,type,data,func)),
        dynamicDeleteProcess: (model,data,func) => dispatch(actions.dynamicDeleteProcess(model,data,func)),
        getMasterTableList: (table) => dispatch(actions.getMasterTableList(table)),

        
    }
}

  
export default connect(mapStateToProps,mapDispatchToProps)(HelpLibrary);

